import { createSlice } from '@reduxjs/toolkit'
import { CENTERS } from '../../utils/constants/actionTypes'
import createAsyncThunkMiddleware from '../../utils/helpers/createAsyncThunkMiddleware'
import OwnCentersServices from './ownCenters.service'
import extraReducersCommon from '../common/extraReducers'

/**
 * body - {...}
 */
export const createCenter = createAsyncThunkMiddleware(
  CENTERS.CREATE,
  OwnCentersServices.create,
)

/**
 * filter, limit, page
 */
export const getAllCenters = createAsyncThunkMiddleware(
  CENTERS.GET_ALL,
  OwnCentersServices.getAll,
)

/**
 * { userId, body - {...}}
 */
export const updateCenter = createAsyncThunkMiddleware(
  CENTERS.UPDATE,
  OwnCentersServices.update,
)

/**
 * roleId
 */
export const removeCenter = createAsyncThunkMiddleware(
  CENTERS.REMOVE,
  OwnCentersServices.remove,
)

const initialState = []

const centers = createSlice({
  name: 'centers',
  initialState,
  reducers: {},
  extraReducers: extraReducersCommon(
    createCenter,
    updateCenter,
    getAllCenters,
    removeCenter,
  ),
})

export default centers.reducer
